import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  static targets = ["fileInput"];
  static values = { fileParams: Object };

  connect() {
    this.$element = $(this.element);
    this.token = document.querySelector('meta[name="csrf-token"]')?.content;
  }

  onClick() {
    this.fileInputTarget.click();
  }

  fileSelected(event) {
    const file = event.target.files[0];
    let formData = new FormData();
    formData.append("file", file);

    event.target.value = "";

    fetch("/files/upload", {
      method: "POST",
      headers: { "X-CSRF-Token": this.token },
      body: formData,
    })
      .then((response) => response.json())
      .then((json) => {
        const detail = {
          blob_signed_id: json.signed_id,
          fileParams: this.fileParamsValue,
        };

        this.element.dispatchEvent(
          new CustomEvent("fileUploaded", { detail, bubbles: true })
        );
      });
  }
}
